import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import PolygonEdgeHero from "./PolygonEdgeHero";
import WhyPolygonzkEVM from "./WhyPolygonzkEVM";
import EthereumScalability from "./EthereumScalability";
import EthereumCompatibility from "./EthereumCompatibility";
import DeFiSolutions from "./DeFiSolutions";

function PolygonEdge() {
  return (
    <div>
      <Header />
      <PolygonEdgeHero />
      <WhyPolygonzkEVM />
      <EthereumScalability />
      <DeFiSolutions />
      <EthereumCompatibility />
      <Footer />
    </div>
  );
}

export default PolygonEdge;
